export class ModuleModel {
    modulesMasterId: number;
    moduleName: string;
    moduleIcon: string;
    packageType: string;
    isChargeCategoryApplicable: boolean;
    modelValue: number;
    isPackageApplicable: boolean;
}